import { Offcanvas } from 'react-bootstrap'
import agentBillImg from '../../../assets/images/agentbill.svg'
import QuickSuiteChatEmbed from './QuickSuiteChatEmbed'
import { QuickSuiteChatDrawerProps } from './types'
import './QuickSuiteChatDrawer.scss'

const CHAT_HEIGHT = '700px'

const QuickSuiteChatDrawer = ({ isOpen, onClose, agentArn, agentId }: QuickSuiteChatDrawerProps) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose} placement="end" style={{ width: '500px' }}>
      <Offcanvas.Header closeButton className="quick-suite-chat-drawer__header">
        <Offcanvas.Title className="quick-suite-chat-drawer__title">
          <img src={agentBillImg} alt="Agent Bill" height={32} />
          <span>
            Ask <span className="quick-suite-chat-drawer__badge">Bill</span>
          </span>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column p-0" style={{ height: CHAT_HEIGHT }}>
        {isOpen && (
          <div style={{ flex: 1, minHeight: 0 }}>
            <QuickSuiteChatEmbed agentArn={agentArn} agentId={agentId} />
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default QuickSuiteChatDrawer
